;(function () {
    var SimpleTooltip
    var mouseInContainer = false;
  
    SimpleTooltip = class SimpleTooltip {
      constructor (el) {
        this.$el = $(el)
        this.value = this.$el.attr('data-tooltip')
        this.$el.attr('data-tooltip', null)
        this.initContainer()
        this.attachContentToEl()
        this.initElEvents()
        this.initContainerEvents()
      }
  
      initContainer () {
        this.$container = $(
          "<span class='tooltip' aria-hidden='true'></span>"
        )
        this.$el.after(this.$container)
        return this.initBalloon()
      }
  
      initBalloon () {
        this.$balloon = $(
          `<span class='tooltip-balloon text-field-label-2' hidden>${this.value}</span>`
        )
        this.$balloon.attr('id', `${this.$el.attr('id')}-balloon`)
        return this.$container.append(this.$balloon)
      }
  
      attachContentToEl () {
        var valueElement
        valueElement = $(
          `<span class='tooltip-hidden'> (${this.value})</span>`
        )
        if (this.$el.is('input, textarea, select')) {
          return $(`label[for='${this.$el.attr('id')}'`).append(valueElement)
        } else {
          return this.$el.append(valueElement)
        }
      }
  
      initElEvents () {
        this.$el.focusin(() => {
          if (!this.$container.is(':hover') && !mouseInContainer) {
            this.$container[0].style.transform = "translate(-50%, -50%)"
            this.show()
            var ballonWidth = (this.$balloon[0].offsetWidth / 2) + 16
            this.$container[0].style.left = "calc(50% - " + ballonWidth + "px)";
            this.$container[0].style.top = "50%"
            return this.show()
          }
        })
        this.$el.focusout(() => {
          if (!this.$container.is(':hover')) {
            return this.hide()
          }
        })
        this.$el.mouseenter((e) => {
          mouseInContainer = true;
            var rect = e.target.getBoundingClientRect();
            var mouseX = e.clientX - rect.left
            var mouseY = e.clientY - rect.top
            var center = (this.$balloon[0].offsetWidth / 2) - 4
          this.$container[0].style.transform = "translate(0%, 0%)"
          this.$container[0].style.left = (mouseX - center) + "px"
          this.$container[0].style.top = (mouseY + 40) + "px"
          return this.show()
        })
        this.$el.mouseleave(() => {
          mouseInContainer = false;
          if (!this.$el.is(':focus')) {
            return this.hide()
          }
        })
        this.$el.mousemove((e) => {
          this.show()
          var rect = e.target.getBoundingClientRect();
          var mouseX = e.clientX - rect.left
          var mouseY = e.clientY - rect.top
          var center = (this.$balloon[0].offsetWidth / 2) - 4
  /*         var mouseX = e.clientX
          var mouseY = e.clientY */
          this.$container[0].style.transform = "translate(0%, 0%)"
          this.$container[0].style.left = (mouseX - center) + "px"
          this.$container[0].style.top = (mouseY + 40) + "px"
  
        })
        return this.$el.keyup(e => {
          if (e.keyCode === 27) {
            // Esc
            if (this.$balloon.is(':visible')) {
              return this.hide()
            } else {
              return this.show()
            }
          }
        })
      }
  
      initContainerEvents () {
        this.$container.mouseenter(() => {
          return this.show()
        })
        return this.$container.mouseleave(() => {
          if (!this.$el.is(':focus')) {
            return this.hide()
          }
        })
      }
  
      show () {
        return this.$balloon.attr('hidden', false)
      }
  
      hide () {
        return this.$balloon.attr('hidden', true)
      }
    }
  
    $(document).ready(function () {
      return $('[data-tooltip]').each(function () {
        return new SimpleTooltip(this)
      })
    })
  }.call(this))